// The mark of uncharted water, the one picture of an empty state in the
// hub (ui-map-interface.md §16.15, R1742). It stands in a module of its
// own, because `panel.ts` `empty` and `panels/optcards.ts` `emptyNote`
// both draw it, and the game menu imports the second without the hub.

/**
 * The mark of uncharted water (ui-map-interface.md §16.15, R1742): two
 * contours that break off and a sounding line whose lead found no bottom.
 * It is one small inline SVG in `currentColor`, so it takes the ink of
 * the block it stands in and holds no colour of its own. It does not
 * move, so reduced motion has nothing to stop.
 */
export const UNCHARTED_MARK = '<svg class="eg" viewBox="0 0 40 24" width="40" height="24"'
  + ' aria-hidden="true" focusable="false" fill="none" stroke="currentColor"'
  + ' stroke-width="1" stroke-linecap="round">'
  + '<path d="M2 8c6-4 12 4 18 0s9-3 12-1" stroke-dasharray="2 3"/>'
  + '<path d="M2 15c5-3 10 3 15 0" stroke-dasharray="2 3" opacity=".55"/>'
  + '<path d="M33 3v14" stroke-dasharray="1 2.5"/>'
  + '<circle cx="33" cy="20" r="1.6"/></svg>';
